export default class MobileMenu {
    hidden = true;

    constructor() {
        this.wrapperElement = document.querySelector('.mobile-overlay-menu-wrapper');
        this.headerMenuTriggerElement = document.querySelector('.mobile-header__menu-trigger');
        this.wrapperElement = document.querySelector('.mobile-overlay-menu-wrapper');
        this.menuCloseElement = document.querySelector('.mobile-overlay-menu-wrapper__close');

        this.create();
        this.headerMenuTriggerElement.addEventListener('click', this.onMenuTriggerClick.bind(this));
        this.menuCloseElement.addEventListener('click', this.onMenuTriggerClick.bind(this));

        document.querySelectorAll('.mobile-overlay-main-menu-item--parent > .mobile-overlay-main-menu-item__link').forEach(el => el.addEventListener('click', this.onParentItemClick.bind(this)));
    }

    create() {
        let items = this.collectMenuItems();
        let html = '';

        for (let item of items) {
            html += `
                <li class="mobile-overlay-main-menu-item mobile-overlay-main-menu-item--level-1 ${item.items ? 'mobile-overlay-main-menu-item--parent' : ''}">
                    <a class="mobile-overlay-main-menu-item__link" href="${item.link}" ${ item.style ? `style="${item.style}"` : ''}>${item.text}</a>
                    ${ item.items ? `
                        <div class="mobile-overlay-main-menu-item__arrow"></div>
                        <ul class="mobile-overlay-main-menu mobile-overlay-main-menu--level-2">
                            ${item.items.map((item) => {
                                return `
                                    <li class="mobile-overlay-main-menu-item mobile-overlay-main-menu-item--level-2">
                                        <a class="mobile-overlay-main-menu-item__link" href="${item.link}">${item.text}</a>
                                    </li>
                                `;                
                            }).join('')}
                        </ul>
                    ` : ''}
                </li>
            `;
        }

        document.querySelector('.mobile-overlay-main-menu.mobile-overlay-main-menu--level-1').innerHTML = html;
    }

    collectMenuItems() {
        const firstLevelElements = document.querySelectorAll('.main-menu__list > li');
        const menuItems = [];

        // Collect menu data
        for (let l1Item of Array.from(firstLevelElements )) {
            let link = l1Item.querySelector(':scope > .main-menu__link');
            let subLinks = l1Item.querySelectorAll('.main-menu__submenu-link');

            let item = {
                link: link.getAttribute('href'),
                text: link.textContent.trim(),
                style: link.getAttribute('style'),
            };

            if (item.link === '/catalog/') {
                continue;
            }

            if (subLinks.length > 0) {
                item.items = [];

                for (let subLink of Array.from(subLinks)) {
                    item.items.push({
                        link: subLink.getAttribute('href'),
                        text: subLink.textContent.trim(),
                    });
                }
            }

            menuItems.push(item);
        }

        return menuItems;
    }

    onMenuTriggerClick(e) {
        e.preventDefault();

        this.toggleMenu();
    }

    toggleMenu() {
        if (this.hidden) {
            this.show();
        } else {
            this.hide();
        }
    }

    show() {
        this.headerMenuTriggerElement.querySelector('.hamburger-icon').classList.add('hamburger-icon--opened');

        this.wrapperElement.classList.remove('hidden');
        document.body.classList.add('u-unscrollable');

        setTimeout(() => {
            this.wrapperElement.classList.add('mobile-overlay-menu-wrapper--visible');
        }, 1);

        setTimeout(() => {
            this.menuCloseElement.querySelector('.hamburger-icon').classList.add('hamburger-icon--opened');
        }, 1);

        this.hidden = false;
    }

    hide() {
        this.headerMenuTriggerElement.querySelector('.hamburger-icon').classList.remove('hamburger-icon--opened');
        this.wrapperElement.classList.remove('mobile-overlay-menu-wrapper--visible');

        setTimeout(() => {
            this.wrapperElement.classList.add('hidden');
            document.body.classList.remove('u-unscrollable');
        }, 250);

        setTimeout(() => {
            this.menuCloseElement.querySelector('.hamburger-icon').classList.remove('hamburger-icon--opened');
        }, 1);

        this.hidden = true;
    }

    onParentItemClick(e) {
        e.preventDefault();

        const modifier = 'mobile-overlay-main-menu-item--expanded';
        const itemElement = e.currentTarget.closest('.mobile-overlay-main-menu-item');
        const isExpanded = itemElement.classList.contains(modifier);

        this.wrapperElement.querySelectorAll(`.${modifier}`).forEach(el => el.classList.remove(modifier));

        if (!isExpanded) {
            itemElement.classList.toggle(modifier);
        }
    }
}